/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetryNonCapturedPaymentsDto
 */
export interface RetryNonCapturedPaymentsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof RetryNonCapturedPaymentsDto
     */
    paymentIds: Array<number>;
}

/**
 * Check if a given object implements the RetryNonCapturedPaymentsDto interface.
 */
export function instanceOfRetryNonCapturedPaymentsDto(value: object): value is RetryNonCapturedPaymentsDto {
    if (!('paymentIds' in value) || value['paymentIds'] === undefined) return false;
    return true;
}

export function RetryNonCapturedPaymentsDtoFromJSON(json: any): RetryNonCapturedPaymentsDto {
    return RetryNonCapturedPaymentsDtoFromJSONTyped(json, false);
}

export function RetryNonCapturedPaymentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetryNonCapturedPaymentsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIds': json['paymentIds'],
    };
}

export function RetryNonCapturedPaymentsDtoToJSON(json: any): RetryNonCapturedPaymentsDto {
    return RetryNonCapturedPaymentsDtoToJSONTyped(json, false);
}

export function RetryNonCapturedPaymentsDtoToJSONTyped(value?: RetryNonCapturedPaymentsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentIds': value['paymentIds'],
    };
}

